const miniHowItWorksData = [
  {
    id: "01",
    text: "Every field is recreated digitally and divided into interactive fan zones.",
  },
  {
    id: "02",
    text: "Fans can claim fractional ownership in one or more zones and participate throughout the season.",
  },
  {
    id: "03",
    text: "The more you participate, the more points, status, and experiences you unlock.",
  },
  {
    id: "04",
    text: "And every dollar of your purchase helps support your favorite sports and athletes.",
  },
];

export default miniHowItWorksData;
